// Global VARASUN "V" watermark — a fixed, non-interactive background layer that
// sits behind all page content (z-index: -1) and shows through the site's
// semi-translucent section backgrounds. GPU-composited transform animation only
// (breathing drift + periodic light sweep); static on mobile and reduced-motion.
const VBackdrop = () => (
    <div className="v-backdrop" aria-hidden="true" data-testid="v-backdrop">
        <img src="/v-mark-bg.webp" alt="" decoding="async" fetchPriority="low" className="v-backdrop-mark" />
        <span
            className="v-backdrop-shine"
            style={{ WebkitMaskImage: "url(/v-mark-bg.webp)", maskImage: "url(/v-mark-bg.webp)" }}
        />
    </div>
);

export default VBackdrop;
